import { WalkThroughAnimation, TriggerType, Camera } from "../base";
import { webcadDefines } from "./index";
import * as THREE from "three";

/* WebCadWalkThroughAnimation
 * WebCad用ウォークスルーアニメーションオブジェクト.
 */
export class WebCadWalkThroughAnimation extends WalkThroughAnimation {
    constructor(anims: any, position: THREE.Vector3, type: TriggerType) {
        super(anims, position, type);
        this.minDist = webcadDefines.WebCadCameraDefs.wtAnimTriggerMinDist;
        this.maxDist = webcadDefines.WebCadCameraDefs.wtAnimTriggerMaxDist;
    }
    /* toFreeze
     *
     */
    public toFreeze(camera: Camera, timeStamp: number): boolean {
        var passedScale: number = this.duration / this.maxDuration;
        if ((0.25 < passedScale) && (passedScale < 0.75)) {
            return this.position.distanceTo(camera.position) - Math.abs(this.position.y - camera.position.y) < webcadDefines.WebCadCameraDefs.wtAnimSuspentionDist;
        }
        return false;
    }
}
